// src/evaluations/potentialReport/potentialReportAccess.js
// Qué reporte muestra "Ver resultados" (PLAN_UNIFICACION_ASSESSMENT.md §7.10).
//
// Desde el 2026-10-18 el Informe de Potencial reemplaza al reporte anterior: el
// backend marca con `reportType: 'potential'` cada respuesta que procesa (también
// las antiguas que se reprocesan) y en esas se muestra solo el informe nuevo. Las
// procesadas antes muestran solo el reporte anterior (vista Resultados + PDF/Word
// guardados). Nunca se muestran los dos, para ningún rol.
//
// Para volver al reporte anterior en todas: que `onlyPotential` sea siempre false.
// El PDF y el Word anteriores se siguen generando para todas las respuestas, así
// que no falta nada.

export const POTENTIAL_REPORT_TYPE = 'potential';

export const hasPotentialReport = (data) => data?.reportType === POTENTIAL_REPORT_TYPE;

export function getResultModalView(data) {
    const completed = Boolean(data?.id) && data?.overallStatus === 'completed';
    return { onlyPotential: completed && hasPotentialReport(data) };
}
